import { ReactComponent as IconDownload } from '@/assets/svgs/download.svg'
import { ToastContext } from '@/context/toast/index'
import api from '@/services/api/dataElements.js'
import { useContext, useState } from 'react'

export default function CsvTemplateCard({ item }) {
	const jsonTemplate = `json_${item?.id}`
	const csvTemplate = `csv_${item?.id}`
	const { addToastMessage } = useContext(ToastContext)

	const [jsonPath, setJsonPath] = useState(null)
	const [csvPath, setCsvPath] = useState(null)

	const handleDownload = async (e) => {
		e.preventDefault();
		const [error, response] = await api.getDataElementTemplate(item?.id)

		if (error) {
			return addToastMessage(
				error?.error?.message || 'Unable to retrieve JSON template',
			)
		}

		const jsonPath = `data:text/json;charset=utf-8,${encodeURIComponent(
			JSON.stringify(response.jsonTemplate),
		)}`

		const csvPath = `data:text/csv;charset=utf-8,${response.csvTemplate}`

		setJsonPath(jsonPath)
		setCsvPath(csvPath)
		document.getElementById(csvTemplate).click()
	}

	return (
		<div className="eclip-landing-csv-download-card" >
			<div className="eclip-landing__flex">
				<div className="eclip-landing-csv-download-box">CSV</div>
				<a
					hidden
					href={jsonPath}
					id={jsonTemplate}
					download={`json_template_${item.id}.json`}
				>
					JSON Template
				</a>
				<a
					hidden
					href={csvPath}
					id={csvTemplate}
					download={`csv_template_${item.id}.csv`}
				>
					CSV Template
				</a>
				.
				<div className="eclip-landing_cursor-mode__pointer" onClick={handleDownload}>
					<IconDownload />
				</div>
			</div>
			<div className="eclip-landing-csv-download--label trim--three-lines">
				{item.name}
			</div>
		</div>
	)
}
